module.exports = __webpack_public_path__ + "img/B&R_explore_two.5664be9e.png";